module.exports = __webpack_public_path__ + "img/go.24819fca.png";